import { ComboBoxOption } from '../../../components/datafields/ComboBoxField';
import datevAccountNumbers from '../../../constants/datevAccountNumbers';

export const DATEV_ACCOUNT_NUMBER_OPTIONS: ComboBoxOption[] =
  datevAccountNumbers.map(({ accountNumber, name, group }) => ({
    value: String(accountNumber),
    label: `${accountNumber} - ${name}`,
    group,
  }));

export const DATEV_ACCOUNT_NUMBER_MAP: Record<string, string> =
  Object.fromEntries(
    DATEV_ACCOUNT_NUMBER_OPTIONS.map(opt => [opt.value, opt.label])
  );
